'use strict';

import 'angular';

export default function() {
	return function(obj) {
		return angular.equals({}, obj);
	};
}
